import React from 'react';
import PropTypes from 'prop-types';
import BaseComponent from './BaseComponent';
import LectureIndicator from '../CommonSet/LectureIndicator';
import QuizIndicator from '../CommonSet/QuizIndicator';
import PopupList from '../CommonSet/PopupList';
import MissionIntro from '../CommonSet/MissionIntro';
import ToolTip from '../CommonSet/ToolTip';
import HintList from '../CommonSet/HintList';
import { RenderTypes } from '../../Constants';

class RenderView extends BaseComponent {
    constructor(props) {
        super(props);

        this.handleLectureIdicatorSelect = this.handleLectureIdicatorSelect.bind(
            this
        );
    }

    handleLectureIdicatorSelect(e, index) {
        this.props.emitter.emit('select', e, index);
    }

    createView() {
        let child = null;

        const { item = {} } = this.props;

        switch (item.type) {
            case RenderTypes.QUIZ_INDICATOR:
                child = (
                    <QuizIndicator
                        content={item.content}
                        onClick={this.handleLectureIdicatorSelect}
                    />
                );
                break;
            case RenderTypes.LECTURE_INDICATOR:
                child = (
                    <LectureIndicator
                        content={item.content}
                        theme={item.theme}
                        onClick={this.handleLectureIdicatorSelect}
                    />
                );
                break;
            case RenderTypes.POPUP_LIST:
                child = (
                    <PopupList
                        content={item.content}
                        theme={item.theme}
                        emitter={this.props.emitter}
                    />
                );
                break;
            case RenderTypes.TOOL_TIP:
                child = (
                    <ToolTip
                        content={item.content}
                        isShowMe={item.isShowMe}
                        isForMe={item.isForMe}
                        isPrev={item.isPrev}
                        guideIndex={item.guideIndex}
                        emitter={this.props.emitter}
                    />
                );
                break;
            case RenderTypes.MISSION_INTRO:
                child = (
                    <MissionIntro
                        content={item.content}
                        emitter={this.props.emitter}
                    />
                );
                break;
            case RenderTypes.HINT_LIST:
                child = (
                    <HintList
                        content={item.content}
                        theme={item.theme}
                        emitter={this.props.emitter}
                    />
                );
                break;
        }

        return child;
    }

    render() {
        const { theme = '' } = this.props;

        return <div className={theme}>{this.createView()}</div>;
    }
}

RenderView.displayName = 'RenderView';
RenderView.propTypes = {};

export default RenderView;



// WEBPACK FOOTER //
// ./components/RenderSet/RenderView.js